/* ROTAS69 — UI-доводка виджета Judge.me. Пять самостоятельных механик, вынесенных из
   snippets/r69-judgeme.liquid: перевод ссылки без модалки, подсветка выбранной строки
   гистограммы, скрытие пустой вкладки, пометка ответов магазина и правка ARIA-ролей.
   Здесь они лежат отдельным файлом, потому что Shopify минифицирует assets/*.js и
   срезает комментарии, тогда как инлайновый скрипт уезжает в HTML КАЖДОЙ страницы
   вместе с ними. Замерено: комментарии дают 9-11 КБ brotli на страницу.
   Единственная переменная из Liquid (переведённая подпись) приходит через
   window.__r69JmI18n, который ставится крошечным инлайном перед загрузкой файла. */

  (function () {
    if (window.__r69JmTranslateNoModal) return;
    window.__r69JmTranslateNoModal = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var ctrl = t.closest('.jdgm-review-card__translate-button') || t.closest('.jdgm-translate-button');
      if (!ctrl) return;
      var stop = function (ev) { ev.stopPropagation(); ctrl.removeEventListener('click', stop); };
      ctrl.addEventListener('click', stop);
    }, true);
  })();

  (function () {
    if (window.__r69HistoSelected) return;
    window.__r69HistoSelected = true;
    function sync() {
      var w = document.querySelector('.jdgm-widget-revamp');
      var h = w && (w.querySelector('.jm-histogram') || w);
      if (!h) return;
      var sel = {};
      h.querySelectorAll('.jm-rating-filter__tag').forEach(function (t) {
        var inp = t.querySelector('input');
        if (t.classList.contains('jm-rating-filter__tag--selected') || (inp && inp.checked)) {
          var m = (t.textContent || '').match(/(\d)/);
          if (m) sel[m[1]] = true;
        }
      });
      h.querySelectorAll('.jm-histogram-row').forEach(function (row) {
        var rr = row.querySelector('.jm-histogram-row__rating');
        var rn = rr ? (rr.textContent || '').trim() : '';
        row.classList.toggle('r69-histo-selected', !!sel[rn]);
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest &&
          e.target.closest('.jm-histogram-row, .jm-rating-filter__tag, .jm-filter-panel__clear-btn')) {
        setTimeout(sync, 250); setTimeout(sync, 700);
      }
    }, true);
    var tries = 0, debTimer = null;
    function debSync() { if (debTimer) return; debTimer = setTimeout(function () { debTimer = null; sync(); }, 120); }
    (function init() {
      var w = document.querySelector('.jdgm-widget-revamp');
      var histo = w && w.querySelector('.jm-histogram');
      if (!histo) {
        if (tries++ < 40) setTimeout(init, 500);
        return;
      }
      sync(); setTimeout(sync, 900); setTimeout(sync, 2200);
      // Observe ONLY the histogram, not the whole widget — on the reviews page the widget streams in
      // hundreds of reviews and observing its full subtree fired this constantly (part of the load
      // flicker). childList only, so our own class toggles never re-trigger it.
      try { new MutationObserver(debSync).observe(histo, { childList: true, subtree: true }); } catch (e) {}
    })();
  })();

  (function () {
    if (window.__r69JmHideTab) return;
    // PERF (this was the top-of-page scroll lag): the old version polled every 500ms up to 24x,
    // each time calling getComputedStyle() up EVERY ancestor + getBoundingClientRect() — both FORCE
    // a synchronous style+layout recalc. It ran site-wide on a timer, so it janked scrolling from
    // the very top of every page (~730ms of forced reflow measured via the Long Animation Frames
    // API), and content-visibility made the reviews widget report height 0 so the poll never
    // terminated and ran all 24x. Rewritten with ZERO geometry reads: gate to page templates only
    // (the floating tab is only redundant on the dedicated reviews page), detect that page by the
    // mere existence of an inline all-reviews widget (querySelector, no layout), and catch Judge's
    // async tab with a childList MutationObserver.
    var main = document.getElementById('MainContent');
    var tmpl = (main && main.dataset && main.dataset.template) || '';
    if (tmpl.indexOf('page') !== 0) return; // never runs on product/collection/index — no PDP cost
    window.__r69JmHideTab = true;
    function tryHide() {
      if (!document.querySelector('.jdgm-all-reviews-widget-v2025')) return false; // not the reviews page
      var tabs = document.querySelectorAll('.jdgm-revs-tab, .jdgm-revs-tab-btn');
      if (!tabs.length) return false; // Judge hasn't injected the tab yet
      tabs.forEach(function (t) { t.classList.add('r69-tab-hidden'); });
      return true;
    }
    if (tryHide()) return;
    var mo = new MutationObserver(function () { if (tryHide()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  })();

  (function () {
    if (window.__r69JmReplyTag) return;
    window.__r69JmReplyTag = true;
    function tag() {
      var reps = document.querySelectorAll('.jdgm-review-card__reply-content');
      for (var i = 0; i < reps.length; i++) {
        var box = reps[i].closest('.jm-stack--space-200');
        if (box && !box.classList.contains('r69-reply')) box.classList.add('r69-reply');
      }
    }
    var t = null;
    function schedule() { if (t) return; t = setTimeout(function () { t = null; tag(); }, 250); }
    [400, 1200, 3000, 6000].forEach(function (d) { setTimeout(tag, d); });
    // reviews load via the "Rādīt vairāk" BUTTON (no infinite scroll), so a click listener is enough —
    // no per-scroll work. Filter/sort/show-more all re-render the list on click.
    document.addEventListener('click', schedule, true);
  })();

  (function () {
    if (window.__r69JudgeAria) return;
    window.__r69JudgeAria = true;
    var REVIEW_LINK_LABEL = (window.__r69JmI18n && window.__r69JmI18n.readMore) || '';
    function fix() {
      document.querySelectorAll('.jm-media-grid__container').forEach(function (c) {
        // listbox only when it actually has option children (avoid an empty-listbox violation)
        if (c.querySelector('.jm-media-grid__item') && c.getAttribute('role') !== 'listbox') {
          c.setAttribute('role', 'listbox');
        }
      });
      document.querySelectorAll('.jm-media-grid__item').forEach(function (it) {
        if (it.getAttribute('role') !== 'option') it.setAttribute('role', 'option');
      });
      document.querySelectorAll('.jdgm-tab[aria-controls]').forEach(function (t) {
        t.removeAttribute('aria-controls');
      });
      // Snippet-widget carousel arrows are <i aria-label> — aria-label is prohibited on the generic
      // role; they're clickable, so give them role=button (makes the existing label valid).
      // 2026-08-02: the v2 widget ships them as real <button> elements, which need no role at all —
      // hence the tag guard, so we don't stamp a redundant role=button on a button.
      document.querySelectorAll(
        '.jdgm-rev-snippet-widget__prev-btn, .jdgm-rev-snippet-widget__next-btn, .jdgm-rev-snippet-widget-v2__arrow'
      ).forEach(function (b) {
        if (b.tagName !== 'BUTTON' && b.getAttribute('role') !== 'button') b.setAttribute('role', 'button');
      });
      // Snippet "full review" overlay links render empty (no text, no label) — name them (link-name).
      document.querySelectorAll('.jdgm-rev-snippet-card__full-review-link').forEach(function (a) {
        if (!a.getAttribute('aria-label') && !a.textContent.trim()) a.setAttribute('aria-label', REVIEW_LINK_LABEL);
      });
      // Average-rating summary link: Judge's aria-label is a mismatched English string ("View reviews on
      // the Reviews Site") that doesn't contain the visible "N.N (M reviews)" (label-content-name-mismatch)
      // — and it's untranslated. Drop it so the name falls back to the visible, localized text.
      document.querySelectorAll('a.jm-average-rating-display[aria-label]').forEach(function (a) {
        a.removeAttribute('aria-label');
      });
      // Floating reviews tab: same mismatch — Judge labels it "Click to open Judge.me floating
      // reviews tab" while the visible text is the rating number. Same treatment: drop the label,
      // the name falls back to the visible content.
      document.querySelectorAll('.jdgm-revs-tab-btn[aria-label]').forEach(function (b) {
        b.removeAttribute('aria-label');
      });
      // Histogram rows are role=button with Judge's label "100% (12) reviews with 5 star rating",
      // while the row shows "5 ★★★★★ ▬ 12" — the visible "5 12" is not inside the name
      // (label-content-name-mismatch, axe on the product page 02.11.2026). Dropping the label would
      // lose the percentage and the meaning, so the visible text goes in front of it instead:
      // "5 12 — 100% (12) reviews with 5 star rating" — a voice-control user who says what they see
      // finds the row. Read with textContent from the two text parts (rating, count), not innerText,
      // so no layout is forced. A checker builds the row's visible text by gluing its text nodes
      // (axe: join('')), and the digits sit in two spans with only empty boxes (stars, bar) between
      // them, so it read "512", which no readable label contains — aria-hidden does not change that
      // reading. One space text node after the digit makes it "5 12". Inside the flex row the space
      // is not drawn: row 358×22 px before and after (product page, phone, 02.11.2026).
      // Fixed rows are skipped.
      document.querySelectorAll('.jm-histogram-row[aria-label]').forEach(function (row) {
        var rating = row.querySelector('.jm-histogram-row__rating');
        if (rating && !(rating.nextSibling && rating.nextSibling.nodeType === 3)) rating.after(document.createTextNode(' '));
        var count = row.querySelector('.jm-histogram-row__frequency');
        var visible = [rating && rating.textContent.trim(), count && count.textContent.trim()].filter(Boolean).join(' ');
        var label = row.getAttribute('aria-label');
        if (visible && label.indexOf(visible) !== 0) row.setAttribute('aria-label', visible + ' — ' + label);
      });
      // Judge's review-photo thumbnails render without width/height (Lighthouse unsized-images —
      // the only unsized image left). The frame is square; stamp the ratio (CLS is 0 either way).
      document.querySelectorAll('.jdgm-review-card__media-cover img:not([width])').forEach(function (im) {
        im.setAttribute('width', '96');
        im.setAttribute('height', '96');
      });
    }
    // Apply within one frame of any Judge render (rAF-coalesced), PLUS timed retries as a
    // belt-and-suspenders so the fix has definitely landed before Lighthouse snapshots the a11y tree.
    // Observe document.body — Judge's tabs and the media grid live in DIFFERENT sub-trees, so a
    // widget-scoped observer misses one of them.
    // But only Judge's own DOM can need fixing: every selector above is a jdgm-/jm- class. So a
    // mutation (or a click) schedules fix() only when it touches a node under such a class.
    // Without the gate every mutation on the page ran the eight document-wide querySelectorAll
    // calls: on the collection page (10 800 tags) that was 167 ms of the load at CPU ×4 on a
    // Pixel-class phone (load profile 06.09.2026) while 44 cards upgraded, and one more run per
    // tap anywhere on the page.
    var raf = 0;
    function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; fix(); }); }
    function isJudge(el) {
      var c = el && el.nodeType === 1 ? el.className : '';
      return typeof c === 'string' && (c.indexOf('jdgm') !== -1 || c.indexOf('jm-') !== -1);
    }
    function underJudge(node) {
      for (var n = node, d = 0; n && n.nodeType === 1 && d < 60; n = n.parentNode, d++) if (isJudge(n)) return true;
      return false;
    }
    function touchesJudge(recs) {
      for (var i = 0; i < recs.length; i++) {
        var r = recs[i];
        if (underJudge(r.target)) return true;
        var added = r.addedNodes;
        for (var j = 0; added && j < added.length; j++) if (isJudge(added[j])) return true;
      }
      return false;
    }
    fix();
    [300, 800, 1500, 3000, 5000].forEach(function (d) { setTimeout(fix, d); });
    try {
      new MutationObserver(function (recs) { if (touchesJudge(recs)) schedule(); }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-controls'],
      });
    } catch (e) {}
    document.addEventListener('click', function (e) { if (underJudge(e.target)) schedule(); }, true);
  })();
